import React from 'react';
import { Section } from '../Section';
import { Heading2 } from '../Heading2';
import { FadeUp } from '../FadeUp';
import { LIFESTYLE_IMAGE_1, LIFESTYLE_IMAGE_2, ROUTINE_CHARTS_IMAGE } from '../../data/images';
export function Demo() {
  return <Section data-id="element-110" data-mp="1oronrc4ss8q7">
      <FadeUp data-id="element-111" data-mp="1oukp7afutfje">
        <Heading2 data-id="element-112" data-mp="1kquxwd7sojuo">
          A visual system
          <br data-id="element-113" data-mp="1ks640jopq3oy" />
          your kids <em className="italic" data-id="element-114" data-mp="1ksze9umvrbbu">actually want to follow</em>…
        </Heading2>

        <img src={ROUTINE_CHARTS_IMAGE} alt="Three printable daily routine charts for Emma, Liam and Olivia, fanned out" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto mt-10 block h-auto w-full max-w-[560px]" style={{
        aspectRatio: '3 / 2'
      }} data-id="element-115" data-mp="x1tyffgxwj1j" />

        <div className="mt-5 space-y-1 text-center text-[12px] text-ink/65 md:text-[14px]" data-id="element-116" data-mp="2hgm3p8ljdtfs">
          <p className="whitespace-nowrap" data-id="element-117" data-mp="2cikc1za1olsp">
            <span aria-hidden="true" className="text-gain" data-id="element-118" data-mp="2chixvlxqfj6r">
              ✓
            </span>{' '}
            Customizable — add your kid's name and routine.
          </p>
          <p className="whitespace-nowrap" data-id="element-119" data-mp="2hc11q86ge35k">
            <span aria-hidden="true" className="text-gain" data-id="element-120" data-mp="2hf5cxpic5z5q">
              ✓
            </span>{' '}
            Buy once, print as many times as you need.
          </p>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-[10px]" data-id="element-121" data-mp="2raguefl4pkh6">
          <img src={LIFESTYLE_IMAGE_1} alt="A girl checking off her morning routine board" width={1024} height={1024} loading="lazy" decoding="async" className="block w-full rounded-[8px]" style={{
          aspectRatio: '1 / 1',
          objectFit: 'cover'
        }} data-id="element-122" data-mp="1to9dq7bjw1og" />
          <img src={LIFESTYLE_IMAGE_2} alt="A mom and her son going through the routine board together" width={1024} height={1024} loading="lazy" decoding="async" className="block w-full rounded-[8px]" style={{
          aspectRatio: '1 / 1',
          objectFit: 'cover'
        }} data-id="element-123" data-mp="28egyitp15wsb" />
        </div>

        <p className="mx-auto mt-6 max-w-[520px] text-center text-[15px]" data-id="element-124" data-mp="13taeemiljqoq">
          Stick it on the fridge, the bedroom door, or the bathroom mirror. Your kid checks it off —
          you stop being the reminder.
        </p>
      </FadeUp>
    </Section>;
}